// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8f37deb3","732":"b594ec08","977":"0866da03"}[chunkId] + ".chunk.js";
};